<template>
    <div>
        <div class="row q-col-gutter-md">
            <div class="col col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <qr-code
                    :text="account.address"
                    :size="200"
                    color="#4e54c8"
                    bg-color="#ffffff"
                    error-level="L">
                </qr-code>
            </div>
            <div class="col col-xs-12 col-sm-12 col-md-8 col-lg-8">
                <div style="max-width: 400px; margin: 0 auto">
                    <q-list bordered>
                        <q-item class="q-pb-none">
                            <q-item-section class="col-5">
                                <q-item-label class="text-grey-7">{{$t('payment-methods.templates.amount_to_pay')}}</q-item-label>
                            </q-item-section>

                            <q-item-section class="text-right">
                                <q-item-label>
                                    <currency-format
                                        :value="total_amount"
                                        hide-zero-decimal
                                        hide-white-spaces
                                        class="inline-block"
                                    />
                                    USDT
                                </q-item-label>
                            </q-item-section>
                            <q-item-section side style="padding-left:5px">
                                <q-btn outline
                                       dense
                                       size="sm"
                                       :label="$t('copy')"
                                       color="primary"
                                       @success="$copied($t('validations.field_is_copied', {field: $t('payment-methods.templates.amount_to_pay')}))"
                                       v-clipboard="total_amount"
                                       class="q-px-xs"
                                />
                            </q-item-section>
                        </q-item> <!-- Amount -->
                        <q-item>
                            <q-item-label caption>{{$t('payment-methods.templates.please_pay_the_exact_amount_do_not_round_this_up_down')}}</q-item-label>
                        </q-item>
                        <q-separator/>
                        <q-item>
                            <q-item-section class="col-4">
                                <q-item-label class="text-grey-7">{{$t('payment-methods.templates.address')}}:</q-item-label>
                                <q-item-label>{{ account.address }}</q-item-label>
                            </q-item-section>
                            <q-item-section class="q-pt-none text-right">
                                <q-item-label>
                                    <q-btn
                                        outline
                                        dense
                                        size="sm"
                                        :label="$t('copy')"
                                        color="primary"
                                        @success="$copied($t('validations.field_is_copied', {field: $t('payment-methods.templates.address')}))"
                                        v-clipboard="account.address"
                                        class="q-px-xs"
                                    />
                                </q-item-label>
                            </q-item-section>
                        </q-item> <!-- Address -->
                        <q-separator/>
                        <q-item>
                            <q-item-section class="col-4">
                                <q-item-label class="text-grey-7">{{$t('payment-methods.templates.network')}}:</q-item-label>
                            </q-item-section>

                            <q-item-section class="text-right roboto-mono-400">
                                <q-item-label>
                                    {{ account.network }}
                                </q-item-label>
                            </q-item-section>
                            <q-item-section side style="padding-left:5px">
                                <q-btn outline
                                       dense
                                       size="sm"
                                       :label="$t('copy')"
                                       color="primary"
                                       @success="$copied($t('validations.field_is_copied', {field: $t('payment-methods.templates.network')}))"
                                       v-clipboard="account.network"
                                       class="q-px-xs"
                                />
                            </q-item-section>
                        </q-item> <!-- Network -->
                        <q-separator/>
                    </q-list>
                </div>
            </div> <!-- Payment Details -->
            <div class="col col-12">
                <div class="text-h6 q-mb-sm"><q-icon name="fa fa-info-circle" size="xs" color="primary" /> {{$t('payment-methods.templates.important_payment_instructions')}}:</div>
                <div v-html="instructions" class="instructions"></div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "NZ-USDTDeposit",
    props: {
        instructions: {
            type: String,
            default: ''
        },
        fee: {
            type: Number,
            default: 0
        },
        transfer: {
            type: Object,
            default: ()=>{}
        }
    },
    computed: {
        total_amount() {
            return String(this.transfer.amount + this.fee)
        },
        account() {
            return this.transfer.account_numbers[0]
        }
    },
    data() {
        return {
            openDialog: false,
            networks_map: {
                TRC20: "TRC20",
                IBAN: "IBAN",
                CARD: "Card number",
                WALLET: "Wallet Address"
            }
        }
    },
    methods: {},
    created() {
    },
    mounted() {
    },
    watch: {},
    components: {},
}
</script>
<style>

</style>
